// src/components/ProductCard/UnitAwareProductSize.jsx

'use client'

import { usePreferences } from '@/contexts/ShopPreferences.context';


export default function UnitAwareProductSize({measurements}){
  const { unitSystem } = usePreferences();
  return <>{measurements?.dimensions[unitSystem]?.formatted}</>
}
